import { APP_NAME, APP_NAME_AR } from '../data/brand';
import { keepHonorifics, quranText } from '../data/islam';
import { WHY_NAME } from '../data/name';
import { panel } from '../state';
import { Sheet } from './chrome';
import { SayArabic, SayQuran } from './SayArabic';

// "Why Ahillah?" (panel 'name', from About in Settings and from the update): the word, the verse it comes from, and the
// scholars on what it means, in their own words, set as on "The stars in Islam". Every word is in src/data/name.ts.

export function NamePanel() {
  return (
    <Sheet onClose={() => (panel.value = null)} size="tall" label={`Why ${APP_NAME}?`}>
      <h2 class="sheet-title">Why {APP_NAME}?</h2>
      <div class="name-hero">
        <p class="name-ar" lang="ar" dir="rtl">{APP_NAME_AR}</p>
        <p class="name-tr">{WHY_NAME.say}</p>
      </div>
      <section class="islam-sec">
        <p>{WHY_NAME.intro}</p>
        <blockquote class="islam-quote">
          <p class="islam-ar quran-text" lang="ar" dir="rtl">{quranText(WHY_NAME.verse.arabic)}</p>
          <SayQuran text={WHY_NAME.verse.arabic} />
          <p>{WHY_NAME.verse.english}</p>
          <cite>{WHY_NAME.verse.ref}</cite>
        </blockquote>
        {WHY_NAME.quotes.map((q) => (
          <div key={q.ref}>
            <p>{keepHonorifics(q.lead)}</p>
            <blockquote class="islam-quote">
              <p class="islam-ar" lang="ar" dir="rtl">{q.arabic}</p>
              <SayArabic text={q.arabic} />
              <p>{keepHonorifics(q.english)}</p>
              <cite>{q.ref}</cite>
            </blockquote>
          </div>
        ))}
        <p>{WHY_NAME.close}</p>
        <p class="fine">{WHY_NAME.sources}</p>
      </section>
    </Sheet>
  );
}
